import React, { useState } from 'react'
import { Form } from "react-bootstrap";
import NivelesAcceso from './NivelesAcceso';
import $ from "jquery";

const MiSelector = (props) => {
    const id = props.id

    const [nivel, setNivel] = useState(props.accessLevel)

    const putLevel = (level) => {
//102022 

        let settings = {
            url: process.env.REACT_APP_API_URL + `/usuarios/${id}/level/${(level.length === 2 && (level.substr(1,1) === 'l' || level.substr(1,1) === 'm')) ? level.substring(0,1) : level}`,
            method: "PUT",
            xhrFields: {
                withCredentials: true,
            },
        };
        return $.ajax(settings);
    };

    const handlePonNivel = (e) => {
        putLevel(e.target.value)
        setNivel(e.target.value)
    }

    return (
        <NivelesAcceso title={props.title} onChange={handlePonNivel} value={nivel} className='' accessLevel={nivel} />
    )
}

export default MiSelector
/*
<Form.Control title={props.title} as="select" onChange={handlePonNivel} value={nivel} className=''>
            <option value="2">Hermana</option>
            <option value="9">Secretaría Provincial</option>
            <option value="10">Administración General</option>

        </Form.Control>
*/